import React, { useState } from 'react';
import Icon from '../AppIcon';
import Button from './Button';
import ScheduleConsultationModal from './ScheduleConsultationModal';

const InstitutionQuickActions = ({ institutionId = null, institutionName = 'Institution' }) => {
  const [isComparing, setIsComparing] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [isConsultationModalOpen, setIsConsultationModalOpen] = useState(false);

  const handleStartApplication = () => {
    console.log('Starting application for:', institutionId);
  };

  const handleToggleCompare = () => {
    setIsComparing(!isComparing);
    console.log('Toggle compare:', !isComparing);
  };

  const handleToggleSave = () => {
    setIsSaved(!isSaved);
    console.log('Toggle save:', !isSaved);
  };

  const handleShareInstitution = () => {
    if (navigator.share) {
      navigator.share({
        title: institutionName,
        text: `Check out ${institutionName} on ChineseLangApp`,
        url: window.location?.href,
      })?.catch((error) => console.log('Error sharing:', error));
    } else {
      navigator.clipboard?.writeText(window.location?.href);
      alert('Link copied to clipboard!');
    }
  };

  return (
    <div className="bg-card rounded-lg p-6 shadow-warm-sm border border-border sticky top-24">
      <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
        Quick Actions
      </h3>

      <div className="space-y-3">
        <Button
          variant="default"
          fullWidth
          iconName="PenTool"
          iconPosition="left"
          onClick={handleStartApplication}
        >
          Start Application
        </Button>

        <Button
          variant={isSaved ? 'default' : 'outline'}
          fullWidth
          iconName={isSaved ? 'BookmarkCheck' : 'Bookmark'}
          iconPosition="left"
          onClick={handleToggleSave}
        >
          {isSaved ? 'Saved' : 'Save for Later'}
        </Button>

        <Button
          variant={isComparing ? 'secondary' : 'outline'}
          fullWidth
          iconName="GitCompare"
          iconPosition="left"
          onClick={handleToggleCompare}
        >
          {isComparing ? 'Added to Compare' : 'Compare Programs'}
        </Button>

        <Button
          variant="ghost"
          fullWidth
          iconName="Share2"
          iconPosition="left"
          onClick={handleShareInstitution}
        >
          Share
        </Button>
      </div>

      <div className="mt-6 pt-6 border-t border-border">
        <h4 className="text-sm font-caption font-medium text-foreground mb-3">
          Need Help?
        </h4>
        <div className="space-y-2">
          <button className="w-full flex items-center gap-2 p-2 rounded-md hover:bg-muted transition-smooth text-left">
            <Icon name="MessageCircle" size={18} color="var(--color-primary)" />
            <span className="text-sm text-muted-foreground font-caption">
              Chat with Advisor
            </span>
          </button>
          <button 
            className="w-full flex items-center gap-2 p-2 rounded-md hover:bg-muted transition-smooth text-left"
            onClick={() => setIsConsultationModalOpen(true)}
          >
            <Icon name="Calendar" size={18} color="var(--color-primary)" />
            <span className="text-sm text-muted-foreground font-caption">
              Schedule Consultation
            </span>
          </button>
          <button className="w-full flex items-center gap-2 p-2 rounded-md hover:bg-muted transition-smooth text-left">
            <Icon name="HelpCircle" size={18} color="var(--color-primary)" />
            <span className="text-sm text-muted-foreground font-caption">
              View FAQs
            </span>
          </button>
        </div>
      </div>

      <div className="mt-6 p-4 bg-accent/10 rounded-md border border-accent/20">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} color="var(--color-accent)" />
          <div>
            <p className="text-sm font-medium text-foreground mb-1">
              Application Deadline
            </p>
            <p className="text-xs text-muted-foreground font-caption">
              Submit by March 31, 2026 for Fall 2026 intake
            </p>
          </div>
        </div>
      </div>

      <ScheduleConsultationModal
        isOpen={isConsultationModalOpen}
        onClose={() => setIsConsultationModalOpen(false)}
        instructorName="Academic Advisor"
      />
    </div>
  );
};

export default InstitutionQuickActions;